import ApplicationsChannel from './channels/ApplicationsChannel'

export default {
  ApplicationsChannel
}
